import { render, staticRenderFns } from "./ClientAccess.vue?vue&type=template&id=49db37da"
import script from "./ClientAccess.vue?vue&type=script&lang=js"
export * from "./ClientAccess.vue?vue&type=script&lang=js"
import style0 from "./ClientAccess.vue?vue&type=style&index=0&id=49db37da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports